import { DefaultTheme } from 'styled-components'

const theme: DefaultTheme = {
  borderRadius: '6px',
  breakpoints: {
    desktop: '1024px',
    huge: '1600px',
    maxWidth: '1200px',
    mobile: '340px',
    mobileGallery: '400px',
    mobileSmall: '0px',
    mobileStyleThreshold: '900px',
    phablet: '480px',
    tablet: '768px',
    wide: '1200px',
  },
  cmsModule: {
    width: {
      medium: '1000px',
      small: '750px',
      wide: '1200px',
    },
  },
  colors: {
    black: '#000000',
    blue: '#4d6c8d',
    green: '#4b8e6b',
    discountBg: '#df280a',
    errorMessage: '#df280a',
    grey: '#777',
    greyDark: '#333',
    greyDarkLightened10: '#474747',
    greyLight: '#9e9e9e',
    greyLighter: '#d2d2d2',
    greyLighterer: '#e9e9e9',
    greyLightest: '#f5f5f5',
    greyLightestest: '#fafafa',
    notificationBg: '#fffacd',
    notificationBorder: '#e5db64',
    primary: '#146C92',
    primaryHover: '#105978',
    productGreyOverlay: 'rgba(0,0,0,0.04)',
    red: '#BB0A21',
    redDark: '#9C1D22',
    white: '#fff',
    whiteDarkened5: '#f2f2f2',
  },
  padding: {
    desktop: '30px',
    mobile: '5px',
    phablet: '10px',
    tablet: '20px',
  },
  typography: {
    baseFontColor: '#4E4E4E',
    baseFontSize: '15px',
    baseFontSizeRtl: '13px',
    captionFontColor: 'rgba(51,51,51,0.8)',
    fontFamily: 'Gotham A, Gotham B, Helvetica Neue, Helvetica, Arial, sans-serif',
    lineHeight: 1.5,
  },
  zIndexes: {
    backToTop: 100,
    backdrop: 1100,
    cartMobileFooter: 50,
    cookieBar: 200,
    countryDetection: 2000,
    desktopHeaderNavMenu: 1000,
    galleryFullScreen: 1500,
    globalOverlay: 1110,
    globalSidePane: 1110,
    header: 700,
    headerBackdrop: 500,
    mobileHeader: 1010,
    mobileHeaderMenu: 1020,
    mobileHeaderSearch: 1030,
    plpLoading: 1050,
  },
}

export default theme
